import { useCallback, useState } from 'react'

export function useBoolean(
  init = false
): [boolean, () => void, () => void, () => void] {
  const [state, setState] = useState<boolean>(init)
  const toggle = useCallback(() => {
    setState((currState) => !currState)
  }, [setState])
  const setFalse = useCallback(() => {
    setState(false)
  }, [setState])
  const setTrue = useCallback(() => {
    setState(true)
  }, [setState])
  return [state, setTrue, setFalse, toggle]
}
